<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="fl" style="line-height: 46px;margin-left:20px;">当前位置：</span>
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品与服务</el-breadcrumb-item>
      <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ menuChildName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 二级导航 -->
    <ul class="s-menus clearfix">
      <li class="s-menu">
        <div class="s-menu-t fl">大数据产品</div>
        <ul class="t-menus fl">
          <router-link :to="{ path: '/product_service/data', query: { param: '大数据产品', child: '文献库' } }">
            <li class="t-menu" :class="{ t_menu_hover: menuChildName === '文献库' }">文献库</li>
          </router-link>
          <router-link :to="{ path: '/product_service/data', query: { param: '大数据产品', child: '数据库' } }">
            <li class="t-menu" :class="{ t_menu_hover: menuChildName === '数据库' }">数据库</li>
          </router-link>
          <router-link :to="{ path: '/product_service/data', query: { param: '大数据产品', child: '特色库' } }">
            <li class="t-menu" :class="{ t_menu_hover: menuChildName === '特色库' }">特色库</li>
          </router-link>
        </ul>
      </li>
      <li class="s-menu">
        <router-link :to="{ path: '/product_service/data', query: { param: '信息定制' } }">
          <div class="s-menu-t" :class="{ t_menu_hover: menuName === '信息定制' }">信息定制</div>
        </router-link>
      </li>
      <li class="s-menu">
        <router-link :to="{ path: '/product_service/data', query: { param: '新媒体运营' } }">
          <div class="s-menu-t" :class="{ t_menu_hover: menuName === '新媒体运营' }">新媒体运营</div>
        </router-link>
      </li>
    </ul>
    <!-- 大数据产品-文献库 -->
    <ul class="content" v-show="menuName === '大数据产品' && menuChildName === '文献库'">
      <div class="first clearfix">
        <img src="@/assets/images/service/wxk.jpg" alt />
        <!-- <p
          class="report-p"
        >国研网全面、系统地对国务院发展研究中心1985年以来的研究成果、国研网自主研发/编译报告、与国内知名期刊、媒体、专家合作取得的信息资源进行数字化管理和开发而形成的内容丰富、检索便捷、功能齐全的大型经济社会信息数据库集群，致力于为中国各级党政机关、研究机构和企事业单位准确把握国内外宏观环境、经济金融运行特征、发展趋势及政策走向，从而进行管理决策、理论研究、微观操作提供有价值的参考。</p> -->
        <p class="report-p">
          国研网全面、系统地对国务院发展研究中心1985年以来对外公开发表研究成果、国研网自主研发/编译报告、与国内知名期刊、媒体、专家合作取得的信息资源进行数字化管理和开发而形成的内容丰富、检索便捷、功能齐全的大型经济社会信息数据库集群，致力于为中国各级党政机关、研究机构和企事业单位准确把握国内外宏观环境、经济金融运行特征、发展趋势及政策走向，从而进行管理决策、理论研究、微观操作提供有价值的参考。
        </p>
      </div>
      <div class="report">
        <div class="caption clearfix">
          <span>研究报告库</span>
        </div>
        <ul class="caption-ul clearfix">
          <li class="caption-li">
            <a href="http://drcresearch.drcnet.com.cn/#/" target="_blank">国研视点</a>
          </li>
          <li class="caption-li">
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=08&version=integrated" target="_blank">世经评论</a>
          </li>
          <li class="caption-li">
            <a href="http://report.drcnet.com.cn/#/" target="_blank">国研网系列研究报告</a>
          </li>
        </ul>
        <img src="@/assets/images/service/literature5.png" alt />
      </div>

      <div class="literature">
        <div class="caption clearfix">
          <span>专题文献库</span>
        </div>
        <ul class="wxnewcss2 clearfix">
          <li>
            <a href="javascript:;">
              <img src="@/assets/imgs/wximg1.png" />
              <p>每日推荐</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=18&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg15.png" />
              <p>全球财经</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=03&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg3.png" />
              <p>宏观经济</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=07&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg4.png" />
              <p>区域经济</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=05&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg6.png" />
              <p>行业经济</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/finance/#/">
              <img src="@/assets/imgs/wximg5.png" />
              <p>金融中国</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=06&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg7.png" />
              <p>企业胜经</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=AA10&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg9.png" />
              <p>教育参考</p>
            </a>
          </li>

          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2201&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg12.png" />
              <p>领导讲话</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2202&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg13.png" />
              <p>宏观调控</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2233&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg22.png" />
              <p>创新发展</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2203&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg21.png" />
              <p>体制改革</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2226&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg14.png" />
              <p>财政税收</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2205&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg27.png" />
              <p>市场与物价</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2239&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg29.png" />
              <p>关注十四五</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2231&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg30.png" />
              <p>一带一路</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2237&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg31.png" />
              <p>京津冀协同发展</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2236&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg32.png" />
              <p>长江经济带</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2230&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg25.png" />
              <p>新型城镇化</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2234&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg24.png" />
              <p>智慧城市</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2212&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg15.png" />
              <p>国际贸易</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2213&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg16.png" />
              <p>跨国投资</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2224&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg18.png" />
              <p>国情民生</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2207&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg20.png" />
              <p>社会保障</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2206&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg26.png" />
              <p>人口与发展</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2217&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg17.png" />
              <p>乡村振兴</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2209&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg23.png" />
              <p>资源环境</p>
            </a>
          </li>

          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2235&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg19.png" />
              <p>法治中国</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2241&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg8.png" />
              <p>营商环境</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2210&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg35.png" />
              <p>国内政府管理创新</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/channel.aspx?uid=2211&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg36.png" />
              <p>国外政府管理借鉴</p>
            </a>
          </li>

          <li>
            <a href="http://www.drcnet.com.cn/www/int/leaf.aspx?uid=2223&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg37.png" />
              <p>经济形势分析报告</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/leaf.aspx?uid=2219&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg38.png" />
              <p>发展规划报告</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/leaf.aspx?uid=2222&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg39.png" />
              <p>政府统计公报</p>
            </a>
          </li>
          <li>
            <a href="http://www.drcnet.com.cn/www/int/leaf.aspx?uid=2221&version=integrated" target="_blank">
              <img src="@/assets/imgs/wximg40.png" />
              <p>政府工作报告</p>
            </a>
          </li>
        </ul>
      </div>
    </ul>
    <!-- 大数据产品-特色库 -->
    <ul class="content" v-show="menuName === '大数据产品' && menuChildName === '特色库'">
      <div class="first clearfix">
        <img src="@/assets/images/service/tsk.jpg" alt />
        <p>国研网紧跟国家政策大势，针对用户关注的重点、热点领域，依托先进的技术、丰富的信息资源和专业的研发团队，设计和开发的精品特色数据库。</p>
      </div>
      <ul class="datalists clearfix">
        <li v-for="item in dataLists" :key="item.id">
          <a :href="item.url" target="_blank">
            <img :src="require(`@/assets/images/service/imgs${item.id}.png`)" alt />
            <p class="ellipsis" :title="item.name">{{ item.name }}</p>
          </a>
        </li>
      </ul>
    </ul>
    <!-- 大数据产品-数据库 -->
    <ul class="content" v-show="menuName === '大数据产品' && menuChildName === '数据库'">
      <div class="first clearfix">
        <img src="@/assets/images/service/sjk.jpg" alt />
        <p class="report-p">
          国研网依托自身资源、技术、专业优势，广泛采集国内外政府、权威机构发布的各类经济和社会发展统计数据，通过专业化加工处理，按照科学的指标统计结构体系组织而成的大型数据库集群，是国内较为全面、系统、科学、权威的统计数据库之一，也是投资、决策和学术研究的有力助手。
        </p>
      </div>
      <div class="database">
        <ul class="database-ul clearfix">
          <li class="database-li fl">统计资料库</li>
          <li class="database-li fl" :class="{ database_li_hover: currentTab === item.title }"
            @click="clickTab(item.title)" v-for="item in titleData" :key="item.id">{{ item.title }}</li>
        </ul>
        <div class="datalist">
          <div class="datatab" v-for="item in database" :key="item.id">
            <div class="caption clearfix">
              <span>{{ item.name }}</span>
            </div>
            <div class="datalist_data_ul clearfix" v-if="item.name === '数据'">
              <div class="datalist_data_li fl">货物贸易</div>
              <div class="datalist_data_li fl">贸易指数</div>
              <div class="datalist_data_li fl">服务贸易</div>
              <div class="datalist_data_lis fl">
                <a href="http://trade.drcnet.com.cn/data/goods/china/monthly" target="_blank">中国月度</a>
              </div>
              <div class="datalist_data_lis fl">
                <a href="http://trade.drcnet.com.cn/data/trade-index/china/monthly" target="_blank">中国月度</a>
              </div>
              <div class="datalist_data_liss fl">
                <a href="javascript:;" target="_blank">&ensp;</a>
              </div>

              <div class="datalist_data_lis fl">
                <a href="http://trade.drcnet.com.cn/data/goods/world/monthly" target="_blank">世界月度</a>
              </div>
              <div class="datalist_data_liss fl">
                <a href="javascript:;" target="_blank">&ensp;</a>
              </div>
              <div class="datalist_data_lis fl">
                <a href="http://trade.drcnet.com.cn/data/service-trade/world/annual" target="_blank">世界年度</a>
              </div>

              <div class="datalist_data_lis fl">
                <a href="http://trade.drcnet.com.cn/data/goods/world/annual" target="_blank">世界年度</a>
              </div>
              <div class="datalist_data_liss fl">
                <a href="javascript:;" target="_blank">&ensp;</a>
              </div>
              <div class="datalist_data_liss fl">
                <a href="javascript:;" target="_blank">&ensp;</a>
              </div>
            </div>
            <ul class="clearfix" v-else>
              <li class="fl" v-for="(ele, index) in item.children" :key="index">
                <a :href="ele.url" target="_blank">{{ ele.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ul>
    <!-- 信息定制 -->
    <ul class="content" v-show="menuName === '信息定制'">
      <div class="first clearfix">
        <img src="@/assets/images/service/xxdz.jpg" alt />
        <p>国研网可以根据用户的个性化信息需求，全面整合宏观、区域、金融、行业经济等领域有关文献和数据信息以专供平台、信息简报、数据文件、数据包等方式，有针对性地提供信息定制服务，为其知识获取、科学研究、决策制定提供支撑。</p>
      </div>
      <ul class="list clearfix">
        <li v-for="item in lists" :key="item.id">
          <img :src="require(`@/assets/images/service/bg${item.id}.jpg`)" alt />
        </li>
      </ul>
    </ul>
    <!-- 新媒体运营 -->
    <ul class="content1" v-show="menuName === '新媒体运营'">
      <div class="first clearfix">
        <img src="@/assets/images/service/img4.png" alt />
        <p>
          基于国研网自身内容运营的
          <strong>信息资源和专业经验积累</strong> 优势，面向党政机关、企事业单位提供自媒体内容代运营服务。
        </p>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuName: "",
      menuChildName: "",
      // 特色库
      dataLists: [
        {
          id: 1,
          // name: "世界经济与金融信息平台",
          name: "国研网世界经济数据库系统V1.0",
          url: "http://worldeconomy.drcnet.com.cn"
        },
        {
          id: 2,
          // name: "一带一路研究与决策支持平台",
          name: '国研网“一带一路”研究与决策平台',
          url: "http://ydyl.drcnet.com.cn"
        },
        {
          id: 3,
          // name: "经济·管理案例库",
          name: '经济·管理案例库平台V2.1',
          url: "http://caselib.drcnet.com.cn/"
        },
        { id: 4, name: "政策法规库平台[简称：政策法规库]V2.0", url: "http://policy.drcnet.com.cn/home" },
        {
          id: 5,
          // name: "战略性新兴产业数据库",
          name: '国研网战略性新兴产业数据库应用系统[简称：国研网战略性新兴产业数据库]V1.0',
          url: "http://emerging.drcnet.com.cn"
        },
        { id: 6, name: "文旅产业融合发展信息平台V1.0", url: "http://culture.drcnet.com.cn/" },
        {
          id: 7,
          // name: "数字经济发展观察与监测平台",
          name: '国研网数字经济发展与观察平台[简称：数字经济平台]V1.0',
          url: "http://szjj.drcnet.com.cn/www/szjj/"
        },
        // {
        //   id: 8,
        //   name: "全球绿色金融大数据平台",
        //   url: "http://greene.drcnet.com.cn/web/"
        // }
      ],
      // 信息定制
      lists: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 }
      ],
      // 大数据产品-数据库
      currentTab: "统计数据库",
      titleData: [
        { id: 1, title: "统计数据库" },
        { id: 2, title: "国际贸易研究及决策支持系统" },
        { id: 3, title: "企业大数据平台" }
      ],
      // 大数据产品-数据库
      database: [],
      database1: [
        {
          id: "01",
          name: "世界经济数据库",
          children: [
            {
              id: 0,
              name: "UN MBS",
              url: "http://data.drcnet.com.cn/dataTable?id=706&structureId=706"
            },
            {
              id: 1,
              name: "IMF",
              url: "http://data.drcnet.com.cn/dataTable?id=78&structureId=79"
            },
            {
              id: 2,
              name: "World Bank",
              url: "http://data.drcnet.com.cn/dataTable?id=83&structureId=83"
            },
            {
              id: 3,
              name: "WTO",
              url: "http://data.drcnet.com.cn/dataTable?id=82&structureId=82"
            },
            {
              id: 4,
              name: "OECD",
              url: "http://data.drcnet.com.cn/dataTable?id=81&structureId=81"
            },
            {
              id: 5,
              name: "ADB",
              url: "http://data.drcnet.com.cn/dataTable?id=84&structureId=84"
            },
            {
              id: 6,
              name: "APEC",
              url: "http://data.drcnet.com.cn/dataTable?id=459&structureId=460"
            },
            {
              id: 7,
              name: "ASEAN",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=51&structureId=-14655"
            },
            {
              id: 8,
              name: "Euro Area",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=51&structureId=-3067"
            },
            {
              id: 9,
              name: "世界能源",
              url: "http://data.drcnet.com.cn/dataTable?id=162&structureId=166"
            },
            {
              id: 10,
              name: "世界教育 ",
              url: "http://data.drcnet.com.cn/dataTable?id=488&structureId=488"
            },
            {
              id: 11,
              name: "世界科技",
              url: "http://data.drcnet.com.cn/dataTable?id=502&structureId=502"
            },
            {
              id: 12,
              name: "世界文化",
              url: "http://data.drcnet.com.cn/dataTable?id=532&structureId=532"
            },
            {
              id: 13,
              name: "世界卫生",
              url: "http://data.drcnet.com.cn/dataTable?id=533&structureId=533"
            },
            {
              id: 14,
              name: "世界邮政",
              url: "http://data.drcnet.com.cn/dataTable?id=501&structureId=501"
            }
          ]
        },
        {
          id: "02",
          name: "宏观经济数据库",
          children: [
            {
              id: 0,
              name: "宏观经济",
              url: "http://data.drcnet.com.cn/dataTable?id=1&structureId=3"
            },
            {
              id: 1,
              name: "人口就业",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=48&structureId=-25009"
            },
            {
              id: 2,
              name: "国民经济核算",
              url: "http://data.drcnet.com.cn/dataTable?id=455&structureId=457"
            },
            {
              id: 3,
              name: "价格统计",
              url: "http://data.drcnet.com.cn/dataTable?id=181&structureId=184"
            },
            {
              id: 4,
              name: "居民生活",
              url: "http://data.drcnet.com.cn/dataTable?id=47&structureId=179"
            },
            {
              id: 5,
              name: "财政税收",
              url: "http://data.drcnet.com.cn/dataTable?id=46&structureId=138"
            },
            {
              id: 6,
              name: "资源环境",
              url: "http://data.drcnet.com.cn/dataTable?id=462&structureId=464"
            },
            {
              id: 7,
              name: "固定资产投资",
              url: "http://data.drcnet.com.cn/dataTable?id=447&structureId=448"
            },
            {
              id: 8,
              name: "对外贸易",
              url: "http://data.drcnet.com.cn/dataTable?id=16&structureId=937"
            },
            {
              id: 9,
              name: "城乡建设",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=790&structureId=105677"
            },
            {
              id: 10,
              name: "工业统计 ",
              url: "http://data.drcnet.com.cn/dataTable?id=43&structureId=946"
            },
            {
              id: 11,
              name: "产品产量",
              url: "http://data.drcnet.com.cn/dataTable?id=42&structureId=942"
            },
            {
              id: 12,
              name: "国有资产管理",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=45&structureId=-2538"
            },
            {
              id: 13,
              name: "金融统计",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=41&structureId=104549"
            },
            {
              id: 14,
              name: "教育统计",
              url: "http://data.drcnet.com.cn/dataTable?id=44&structureId=88"
            }
          ]
        },
        {
          id: "03",
          name: "区域经济数据库",
          children: [
            {
              id: 0,
              name: "省级",
              url: "http://data.drcnet.com.cn/dataTable?id=171&structureId=172"
            },
            {
              id: 1,
              name: "市级",
              url: "http://data.drcnet.com.cn/dataTable?id=33&structureId=175"
            },
            {
              id: 2,
              name: "县级",
              url: "http://data.drcnet.com.cn/dataTable?id=37&structureId=37"
            }
          ]
        },
        {
          id: "04",
          name: "行业经济数据库",
          children: [
            {
              id: 0,
              name: "农林牧渔 ",
              url: "http://data.drcnet.com.cn/dataTable?id=371&structureId=374"
            },
            {
              id: 1,
              name: "轻工行业",
              url: "http://data.drcnet.com.cn/dataTable?id=264&structureId=266"
            },
            {
              id: 2,
              name: "纺织工业",
              url: "http://data.drcnet.com.cn/dataTable?id=244&structureId=247"
            },
            {
              id: 3,
              name: "石油化工",
              url: "http://data.drcnet.com.cn/dataTable?id=250&structureId=960"
            },
            {
              id: 4,
              name: "医药行业",
              url: "http://data.drcnet.com.cn/dataTable?id=764&structureId=767"
            },
            {
              id: 5,
              name: "建材工业",
              url: "http://data.drcnet.com.cn/dataTable?id=388&structureId=962"
            },
            {
              id: 6,
              name: "钢铁行业",
              url: "http://data.drcnet.com.cn/dataTable?id=534&structureId=542"
            },
            {
              id: 7,
              name: "有色金属",
              url: "http://data.drcnet.com.cn/dataTable?id=535&structureId=558"
            },
            {
              id: 8,
              name: "机械工业",
              url: "http://data.drcnet.com.cn/dataTable?id=259&structureId=261"
            },
            {
              id: 9,
              name: "汽车工业",
              url: "http://data.drcnet.com.cn/dataTable?id=235&structureId=953"
            },
            {
              id: 10,
              name: "建筑行业",
              url: "http://data.drcnet.com.cn/dataTable?id=746&structureId=747"
            },
            {
              id: 11,
              name: "批发零售",
              url: "http://data.drcnet.com.cn/dataTable?id=750&structureId=753"
            },
            {
              id: 12,
              name: "交通运输",
              url: "http://data.drcnet.com.cn/dataTable?id=227&structureId=954"
            },
            {
              id: 13,
              name: "信息产业",
              url: "http://data.drcnet.com.cn/dataTable?id=72&structureId=955"
            },
            {
              id: 14,
              name: "住宿餐饮",
              url: "http://data.drcnet.com.cn/dataTable?id=757&structureId=760"
            },
            {
              id: 15,
              name: "旅游行业",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=269&structureId=-1690"
            },
            {
              id: 16,
              name: "房地产业",
              url: "http://data.drcnet.com.cn/dataTable?id=735&structureId=737"
            },
            {
              id: 17,
              name: "科学技术",
              url: "http://data.drcnet.com.cn/dataTable?id=241&structureId=707"
            },
            {
              id: 18,
              name: "卫生行业",
              url:
                "http://data.drcnet.com.cn/dataArtical?id=786&structureId=105646"
            },
            {
              id: 19,
              name: "文化产业",
              url: "http://data.drcnet.com.cn/dataTable?id=484&structureId=485"
            },
            {
              id: 20,
              name: "能源工业",
              url: "http://data.drcnet.com.cn/dataTable?id=128&structureId=956"
            }
          ]
        }
      ],
      database2: [
        {
          id: "01",
          name: "数据",
          children: []
        },
        {
          id: "02",
          name: "监测",
          children: [
            {
              id: 0,
              name: "贸易概况",
              url: "http://trade.drcnet.com.cn/monitor/overview"
            },
            {
              id: 1,
              name: "商品结构",
              url: "http://trade.drcnet.com.cn/monitor/structure"
            },
            {
              id: 2,
              name: "贸易竞争",
              url: "http://trade.drcnet.com.cn/monitor/competitiveness"
            }
          ]
        },
        {
          id: "03",
          name: "报告",
          children: [
            {
              id: 0,
              name: "报告",
              url: "http://trade.drcnet.com.cn/report"
            }
          ]
        }
      ],
      database3: [
        {
          id: "01",
          name: "企业画像",
          children: [
            {
              id: 0,
              name: "企业画像",
              url: "http://www.entdata.com.cn/#/index"
            }
          ]
        },
        {
          id: "02",
          name: "特色数据",
          children: [
            {
              id: 0,
              name: "医药企业",
              url: "http://ent.drcnet.com.cn/#/pharma/chemicalMajor"
            },
            {
              id: 1,
              name: "海关企业",
              url: "http://ent.drcnet.com.cn/#/customs/CustomsRight"
            },
            {
              id: 2,
              name: " 工业企业",
              url: "http://ent.drcnet.com.cn/#/industrial/industrialRight"
            }
          ]
        },
        {
          id: "03",
          name: "专题数据",
          children: [
            {
              id: 0,
              name: "上市公司",
              url: "http://ent.drcnet.com.cn/#/enterprises/entDefault"
            },
            {
              id: 0,
              name: "政府采购",
              url: "http://ent.drcnet.com.cn/#/tendering/tedefault"
            },
            {
              id: 0,
              name: "裁判文书",
              url: "http://ent.drcnet.com.cn/#/judgement/judefault"
            }
          ]
        },
        {
          id: "04",
          name: "运行监测",
          children: [
            {
              id: 0,
              name: "发展概况",
              url: "http://ent.drcnet.com.cn/#/developmap"
            },
            {
              id: 0,
              name: "产业地图 ",
              url: "http://ent.drcnet.com.cn/#/industrymap"
            },
            {
              id: 0,
              name: "迁移分析",
              url: "http://ent.drcnet.com.cn/#/migrationmap"
            }
          ]
        }
      ]
    };
  },
  created() {
    this.database = this.database1;
  },
  methods: {
    clickTab(val) {
      this.currentTab = val;
      if (val === "统计数据库") {
        this.database = this.database1;
      } else if (val === "国际贸易研究及决策支持系统") {
        this.database = this.database2;
      } else if (val === "企业大数据平台") {
        this.database = this.database3;
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.menuName = to.query.param;
        this.menuChildName = to.query.child;
      },
      immediate: true
    }
  }
};
</script>

<style lang='scss' scoped>
.el-breadcrumb {
  background: #f3f5f7;
}

.el-breadcrumb__item {
  line-height: 45px;
}

.s-menus {
  box-shadow: 0px 4px 4px -2px #ccc;
  overflow: hidden;
  margin-top: 30px;
  margin-bottom: 30px;

  .s-menu {
    float: left;

    .s-menu-t {
      width: 200px;
      text-align: center;
      line-height: 40px;
      color: #000000;

      &:hover {
        color: #1967b6;
        border-bottom: 2px solid #1967b6;
      }
    }

    .t-menus {
      a {
        display: block;
        float: left;

        .t-menu {
          width: 80px;
          padding-left: 20px;
          line-height: 40px;
          color: #777;
          position: relative;

          &::after {
            position: absolute;
            content: "";
            display: block;
            height: 6px;
            width: 6px;
            border-radius: 50%;
            background: #777;
            top: 16px;
            left: 6px;
          }

          &:hover {
            color: #1967b6;
            border-bottom: 2px solid #1967b6;

            &::after {
              background: #1967b6;
            }
          }
        }
      }
    }

    .t_menu_hover {
      color: #1967b6 !important;
      border-bottom: 2px solid #1967b6;

      &::after {
        background: #1967b6 !important;
      }
    }
  }

  .s-menu+.s-menu {
    border-left: 1px solid #e9e9e9;
  }
}

.content {
  .first {
    img {
      float: left;
    }

    p {
      float: right;
      width: 600px;
      font-size: 14px;
      color: #000000;
      line-height: 28px;
    }
  }

  .list {
    margin: 70px 0;

    li {
      float: left;

      &:hover {
        cursor: pointer;

        p {
          color: #1967b6;
          font-size: 15px;
          font-weight: 600;
        }
      }

      img {
        float: left;
        // width: 209px;
        // height: 140px;
        overflow: hidden;
      }

      p {
        border: 1px solid #d9d9d9;
        line-height: 48px;
        font-size: 14px;
        color: #000000;
        text-align: center;
        transition: all 0.2s;
      }
    }

    li+li {
      margin-left: 18px;
    }
  }

  .datalists {
    margin-top: 70px;
    margin-bottom: 124px;
    width: 100%;

    li {
      height: 165px;
      width: 419px;
      float: left;
      position: relative;
      margin-bottom: 28px;
      overflow: hidden;

      &:hover {
        font-weight: 700;
      }

      p {
        position: absolute;
        bottom: 0px;
        width: 418px;
        height: 34px;
        background: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        color: #ffffff;
        line-height: 34px;
        text-align: center;
      }

      img {
        transition: all 0.6s;

        &:hover {
          transform: scale(1.15);
        }
      }

      a {
        display: block;
      }
    }

    li:nth-child(2n) {
      float: right;
    }
  }

  // 文献库
  .first {
    margin-bottom: 52px;

    .report-p {
      width: 600px;
      margin-top: 2px;
    }
  }

  .caption {
    width: 100%;
    border-bottom: 1px solid#EBEBEB;
    margin-top: 24px;

    span {
      border-bottom: 2px solid #1967b6;
      display: block;
      color: #000000;
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: -1px;
      padding-left: 6px;
      float: left;
    }
  }

  .report {
    .caption-ul {
      margin: 30px 8px 24px 8px;

      .caption-li {
        width: 276px;
        height: 66px;
        float: left;

        a {
          display: block;
          font-size: 15px;
          color: #ffffff;
          line-height: 66px;
          text-align: center;
          transition: all .4s;

          &:hover {
            font-size: 16px;
            font-weight: 700;
          }
        }
      }

      .caption-li+.caption-li {
        margin-left: 20px;
      }

      .caption-li:nth-child(1) {
        background: url(../../assets/images/service/literature2.png) no-repeat center;
      }

      .caption-li:nth-child(2) {
        background: url(../../assets/images/service/literature4.png) no-repeat center;
      }

      .caption-li:nth-child(3) {
        background: url(../../assets/images/service/literature3.png) no-repeat center;
        height: 78px;
      }
    }

    img {
      margin-left: 8px;
    }
  }

  .literature {
    .wxnewcss2 {
      margin: 24px 0 54px 0;

      img {
        width: 50px;
        height: 50px;
        margin: 0 auto;
        opacity: 0.8;
      }

      li {
        float: left;
        text-align: center;
        width: 160px;
        padding-bottom: 15px;
        margin: 8px;
        border: 1px #e3e3e3 solid;

        &:hover {
          border: 1px solid #269bf5;
          box-shadow: 0 0 20px rgba(0, 198, 226, 0.5);
        }
      }

      a {
        color: #333;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }

  // 数据库
  .database {
    .database-ul {
      height: 80px;

      .database-li {
        background: url(../../assets/images/service/data.png) no-repeat center;
        height: 76px;
        width: 214px;
        font-size: 14px;
        color: #2f2f2f;
        line-height: 76px;
        text-align: center;

        &:hover {
          cursor: pointer;
        }
      }

      .database_li_hover {
        background: url(../../assets/images/service/data_hover.png) no-repeat center;
        color: #fff;
        height: 80px;
      }

      .database-li+.database-li {
        margin-left: 10px;
      }
    }

    .datalist {
      width: 100%;
      background: #ffffff;
      border: 1px solid #ebebeb;
      margin-top: 24px;
      margin-bottom: 74px;
      padding: 16px 30px;

      .datatab {
        ul {
          li {
            width: 20%;
            padding-left: 20px;

            a {
              display: block;
              line-height: 60px;
              color: #666;
              font-size: 15px;

              &:hover {
                color: #1967b6;
                cursor: pointer;
              }
            }
          }

          li::before {
            content: "";
            display: block;
            float: left;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #91afca;
            margin-top: 27px;
            margin-right: 10px;
          }
        }

        .datalist_data_ul {
          width: 60%;

          .datalist_data_lis,
          .datalist_data_liss,
          .datalist_data_li {
            width: 33.3%;
            padding-left: 20px;
            line-height: 60px;
            height: 60px;
            color: #666;
            font-size: 15px;

            a {
              display: block;
              line-height: 60px;
              height: 60px;
              color: #666;
              font-size: 15px;

              &:hover {
                color: #1967b6;
                cursor: pointer;
              }
            }
          }

          .datalist_data_lis::before {
            content: "";
            display: block;
            float: left;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #91afca;
            margin-top: 27px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

.content1 {
  .first {
    position: relative;
    width: 100%;
    height: 383px;

    p {
      position: absolute;
      width: 415px;
      font-size: 16px;
      color: #000000;
      line-height: 32px;
      top: 126px;
      left: 34px;

      strong {
        color: #1967b6;
      }
    }
  }
}
</style>